export const profileSyncPersonalInfo = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncPersonalInfo.html',
    bindings: {
        diff: '<',
        onApply: '&',
        onCancel: '&',
    },
};
